import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=2515c2d0&scoped=true"
import script from "./InformationModal.vue?vue&type=script&lang=js"
export * from "./InformationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2515c2d0",
  null
  
)

export default component.exports